import styled from "@emotion/styled";
import { Paper } from "@mui/material";

export const Card = styled(Paper)`
  place-items: center;
  border: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  margin: ${({ theme }) => theme.spacing(1)};
  padding: 2rem;
`;
